import type { ErrorEvent, EventHint } from '@sentry/react';
import type { AxiosError } from 'axios';
import { isAxiosError } from 'axios';

export const addAxiosContext = (event: ErrorEvent, error: AxiosError) => {
  if (error.response) {
    const contexts = { ...event.contexts };
    contexts.Axios = { Response: error.response };
    event.contexts = contexts;
  }
};

export const addAxiosContextRecursive = (event: ErrorEvent, error: unknown) => {
  if (isAxiosError(error)) {
    addAxiosContext(event, error);
  } else if (error instanceof Error && error.cause) {
    addAxiosContextRecursive(event, error.cause);
  }
};

export const handleSentryBeforeSend = (event: ErrorEvent, hint: EventHint) => {
  addAxiosContextRecursive(event, hint?.originalException);

  return event;
};
